import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider, darkTheme, getDefaultConfig } from '@rainbow-me/rainbowkit';
import { WagmiProvider, http, fallback } from 'wagmi';
import { mainnet } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import { Banner } from './comp/Banner';
import { Home } from './comp/Home';

const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY;
const wcProjectId = process.env.REACT_APP_WC_PROJECT_ID || 'demo-project-id';

const transports = {
  [mainnet.id]: fallback(
    [
      ...(alchemyKey
        ? [http(`https://eth-mainnet.g.alchemy.com/v2/${alchemyKey}`)]
        : []),
      http('https://cloudflare-eth.com'),
      http('https://ethereum-rpc.publicnode.com'),
      http('https://rpc.ankr.com/eth'),
      http(),
    ],
    { rank: false }
  ),
};

const wagmiConfig = getDefaultConfig({
  appName: 'SKYFACE MINT',
  projectId: wcProjectId,
  chains: [mainnet],
  transports,
  ssr: false,
});

const queryClient = new QueryClient();

function App() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={darkTheme()}>
          <div className='App'>
            <Banner />
            <div>
              <span style={{ color: '#0178db', fontSize: '1.8em' }}>
                Select as many SKYFACEs as you want!
              </span>
              <br></br>
              <span style={{ color: '#0178db', fontSize: '1.8em' }}>
                And receive your higher resolution original NFTs art straight to
                your wallet!
              </span>
              <br></br>
              <span style={{ color: '#0178db', fontSize: '1.2em' }}>
                Current price: only 0.3 ETH per SKYFACE!
              </span>
            </div>
            <div>
              <br></br>
            </div>
            <Home />
          </div>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
export default App;
